var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { RULE_MODES } from '../../../const/rules';
import RuleValueSlider from './RuleValueSlider';
import RuleValueColor from './RuleValueColor';
import RuleValueText from './RuleValueText';
var RuleValueWrapper = function (_a) {
    var mode = _a.mode, property = _a.property, otherProps = __rest(_a, ["mode", "property"]);
    switch (mode) {
        case RULE_MODES.slider:
            return (React.createElement(RuleValueSlider, __assign({}, otherProps, { property: property })));
        case RULE_MODES.color:
            return (React.createElement(RuleValueColor, __assign({}, otherProps)));
        default:
            return (React.createElement(RuleValueText, __assign({}, otherProps)));
    }
};
export default RuleValueWrapper;
